import { z } from 'zod'

import { apiClient } from '@/utils/axios'

export const ListStateSchema = z.object({
  id: z.number().int().nonnegative(),
  type: z.string(),
  name: z.string(),
  hasMedia: z.boolean(),
})

export const MediaAttributesSchema = z.object({
  label: z.string(),
  price: z.number().nonnegative(),
  scriptId: z.number().int().nonnegative().nullish(),
  empty: z.boolean(),
})

export const MessageMediaSchema = z.object({
  id: z.number().int().nonnegative(),
  creatorId: z.number().int().nonnegative(),
  type: z.string(),
  createdAt: z.string(),
  receivedMedia: z.string(),
  hasAttributes: z.boolean(),
  mediaAttributes: MediaAttributesSchema.nullish(),
  listStates: z.array(ListStateSchema).nullish(),
})

export type MessageMedia = z.infer<typeof MessageMediaSchema>

export const ListMessageMediaResponseSchema = z.array(MessageMediaSchema)

function list(creatorId: number) {
  return apiClient
    .get(`/media/${creatorId}`, { params: { creatorId } })
    .then((response) => ListMessageMediaResponseSchema.parse(response.data))
}

export const messageMediaService = { list }
